import React from 'react';
import Card from '../UI/Card';
import { CONFIG } from '../../config';

/**
 * Stats Section Component
 * 
 * Displays key statistics (years of experience, projects, etc.) in a grid.
 * Serves as social proof and quick overview of achievements.
 */
const Stats = () => {
    return (
        <div className="px-6 sm:px-10 pb-20">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                    {CONFIG.stats.map((stat) => (
                        <Card key={stat.id} className="text-center py-8">
                            <div className="text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white mb-2">
                                {stat.number}
                            </div>
                            <div className="text-sm font-medium text-slate-600 dark:text-slate-400 uppercase tracking-wider">
                                {stat.label}
                            </div>
                        </Card>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Stats;
